import React, { useState } from 'react';
import './purchaseFlow.css';
import { Box, Container, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Notes from './header';
import FooterManual from './footerManual';

const PurchaseFlow = () => {
  const [activeStep, setActiveStep] = useState(1);

  const steps = [
    {
      number: 1,
      title: "ORDER & PAYMENT",
      subtitle: "Reserve Your Vehicle & Complete Payment",
      content: {
        main: "Search for a vehicle you would like to purchase.",
        options: [
          {
            title: "Using “Buy Now”",
            description: "Instantly reserve and buy the vehicle. After placing an order with \"Buy Now\", you can pay via bank transfer using the Proforma Invoice."
          },
          {
            title: "Using “Get a Price Quote”",
            description: "Receive a price quotation by email. If satisfied, we'll prepare your Proforma Invoice for payment."
          },
          {
            title: "Contact Local Offices",
            description: "Visit our local offices or agents for personalized assistance with your purchase."
          }
        ],
        payment: {
          title: "Complete Your Payment",
          description: "Make payment to our bank account and email the receipt to complete your order.",
          methods: [
            "Bank Transfer to our company account",
            "Submit payment receipt via email",
            "Payment confirmation within 24 hours"
          ]
        }
      }
    },
    {
      number: 2,
      title: "SHIPMENT",
      subtitle: "Vehicle Preparation & Shipping",
      content: {
        main: "When payment is confirmed, we begin the shipping process.",
        features: [
          "Receive shipping schedule and updates",
          "Original documents prepared for customs",
          "Bill of Lading delivered by DHL Express",
          "Track your vehicle with our CAP system"
        ]
      }
    },
    {
      number: 3,
      title: "DELIVERY",
      subtitle: "Receive Your Vehicle",
      content: {
        main: "Your vehicle arrives at the agreed destination.",
        features: [
          "Clear customs with required documents",
          "Optional City Delivery Service available",
          "Professional clearing assistance",
          "Final vehicle inspection and handover"
        ],
        note: "Enjoy driving your new car!"
      }
    }
  ];

  return (
    <Box
      className="container-main-support"
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Header */}
      <Box sx={{ marginBottom: "0%" }}>
        <Notes />
      </Box>

      {/* Background Image Section */}
      <Box
        className="image-container-purchase"
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "35vh", sm: "40vh", md: "50vh", lg: "50vh" },
          backgroundColor: "black",
        }}
      >
        <Box
          component="img"
          src="/image/AllSeeModelsBackgroungCar.png"
          alt="purchase process background"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.3,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "white",
            width: "100%",
            padding: { xs: "0 10px", sm: "0 15px", md: "0 20px" },
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { 
                xs: "1.5rem", 
                sm: "2rem", 
                md: "2.5rem", 
                lg: "3.5rem" 
              },
              fontWeight: "800",
              marginBottom: { xs: "0.5rem", sm: "0.75rem", md: "1rem" },
              textShadow: "2px 2px 8px rgba(0,0,0,0.8)",
              letterSpacing: { xs: "-0.5px", md: "0px" },
            }}
          >
            Your Journey to Ownership
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontSize: { 
                xs: "0.85rem", 
                sm: "1rem", 
                md: "1.3rem",
                lg: "1.5rem" 
              },
              fontWeight: "400",
              textShadow: "1px 1px 4px rgba(0,0,0,0.6)",
              opacity: 0.9,
              lineHeight: 1.4,
            }}
          >
            Simple, Secure, and Seamless Vehicle Purchase
          </Typography>
        </Box>
      </Box>

      {/* Main Content Container */}
      <Box 
        className="content-section-purchase"
        sx={{
          position: "relative",
          width: "100%",
          minHeight: "60vh",
          paddingBottom: { xs: "30px", sm: "40px", md: "50px" },
        }}
      >
      
        <Box
          sx={{
            width: { xs: "95%", sm: "92%", md: "90%", lg: "88%" },
            maxWidth: "1300px",
            backgroundColor: "#FFFFFF",
            border: "3px solid red",
            borderRadius: { xs: "10px", sm: "12px", md: "15px" },
            display: "flex",
            flexDirection: "column",
            boxShadow: { 
              xs: "0 5px 15px rgba(220, 38, 38, 0.08)",
              md: "0 10px 30px rgba(220, 38, 38, 0.1)" 
            },
            overflow: "hidden",
            margin: "0 auto",
            transform: { xs: "translateY(-30px)", sm: "translateY(-40px)", md: "translateY(-50px)" },
          }}
        >
          {/* Header with Gradient */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #DC2626 0%, #1E3A8A 100%)",
              padding: { xs: "1.2rem 1rem", sm: "1.5rem 1.5rem", md: "2rem 2rem" },
              borderBottom: "3px solid #000000",
            }}
          >
            <Typography
              sx={{
                fontWeight: "800",
                fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.8rem", lg: "28px" },
                color: "#FFFFFF",
                textAlign: "center",
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                letterSpacing: "0.5px",
              }}
            >
              PURCHASE PROCESS GUIDE
            </Typography>
          </Box>

          {/* Purchase Flow Content */}
          <Box
            sx={{
              width: "100%",
              padding: { 
                xs: "20px 15px", 
                sm: "25px 20px", 
                md: "3% 4%",
                lg: "3% 8%"
              },
              backgroundColor: "#FFFFFF",
            }}
          >
            <div className="purchase-flow">
              <div className="steps-container">
                <div className="steps-progress">
                  {steps.map((step, index) => (
                    <React.Fragment key={step.number}>
                      <div className="step-progress-item">
                        <div 
                          className={`progress-circle ${activeStep >= step.number ? 'active' : ''} ${activeStep === step.number ? 'current' : ''}`}
                          onClick={() => setActiveStep(step.number)}
                          style={{ cursor: 'pointer' }}
                        >
                          <span className="step-number">{step.number}</span>
                          <div className="pulse-ring"></div>
                        </div>
                        <div className="step-title">{step.title}</div>
                      </div>
                      
                      {/* Arrow between steps */}
                      {index < steps.length - 1 && (
                        <div className="step-arrow">
                          <ArrowForwardIosIcon 
                            sx={{ 
                              color: activeStep > step.number ? '#d32f2f' : '#bdc3c7',
                              fontSize: { xs: '1.2rem', sm: '1.5rem', md: '2rem' },
                              transition: 'color 0.3s ease',
                              flexShrink: 0,
                            }} 
                          />
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
      
                <div className="steps-content">
                  {steps.map((step) => (
                    <div 
                      key={step.number} 
                      className={`step-content ${activeStep === step.number ? 'active' : ''}`}
                    >
                      <div className="content-header">
                        <h2 className="step-main-title">{step.title}</h2>
                        <p className="step-subtitle">{step.subtitle}</p>
                      </div>
                      
                      <div className="content-body">
                        <p className="main-description">{step.content.main}</p>
                        
                        {/* 2x2 Layout for Step 1 - Responsive */}
                        {(step.content.options || step.content.payment) && step.number === 1 && (
                          <Box 
                            sx={{ 
                              display: 'grid',
                              gridTemplateColumns: { 
                                xs: '1fr',
                                sm: 'repeat(2, 1fr)',
                                md: 'repeat(2, 1fr)',
                              },
                              gap: { xs: 2, sm: 2.5, md: 3 },
                              mt: { xs: 2, sm: 2.5, md: 3 },
                            }}
                          >
                            {/* Render the three options */}
                            {step.content.options.map((option, idx) => (
                              <Box 
                                key={idx}
                                sx={{ 
                                  display: 'flex', 
                                  flexDirection: 'column',
                                  height: '100%',
                                }} 
                              >
                                <div className="option-card">
                                  <div className="option-icon">✓</div>
                                  <h4>{option.title}</h4>
                                  <p>{option.description}</p>
                                </div>
                              </Box>
                            ))}
      
                            {/* Render the payment section */}
                            {step.content.payment && (
                              <Box 
                                sx={{ 
                                  display: 'flex', 
                                  flexDirection: 'column',
                                  height: '100%',
                                }}
                              >
                                <div className="option-card">
                                  <div className="option-icon">✓</div>
                                  <h3>{step.content.payment.title}</h3>
                                  <p>{step.content.payment.description}</p>
                                </div>
                              </Box>
                            )}
                          </Box>
                        )}
      
                        {/* Features Grid for Steps 2 and 3 */}
                        {step.content.features && (
                          <div className="features-grid">
                            {step.content.features.map((feature, idx) => (
                              <div key={idx} className="feature-item">
                                <div className="feature-icon">→</div>
                                <span>{feature}</span>
                              </div>
                            ))}
                          </div>
                        )}
      
                        {/* Delivery Note */}
                        {step.content.note && (
                          <div className="delivery-note">
                            <div className="note-icon">🎉</div>
                            <p>{step.content.note}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Box sx={{ width: "100%", marginTop: "auto" }}>
        <FooterManual />
      </Box>
    </Box>
  );
};

export default PurchaseFlow;